import { PlateContent } from 'platejs/react';
import { cn } from '~/lib/utils';

type EditorContentProps = {
    placeholder?: string;
    disabled?: boolean;
    className?: string;
};

export const EditorContent = ({
    placeholder = 'Text eingeben...',
    disabled = false,
    className,
}: EditorContentProps) => {
    return (
        <PlateContent
            className={cn(
                'min-h-[200px] w-full px-3 py-2 text-sm',
                'focus:outline-none',
                'prose prose-sm max-w-none dark:prose-invert',
                '[&_p]:m-0 [&_p]:mb-2',
                '[&_h1]:text-2xl [&_h1]:font-bold [&_h1]:mt-4 [&_h1]:mb-2',
                '[&_h2]:text-xl [&_h2]:font-bold [&_h2]:mt-3 [&_h2]:mb-2',
                '[&_h3]:text-lg [&_h3]:font-semibold [&_h3]:mt-2 [&_h3]:mb-1',
                '[&_blockquote]:border-l-4 [&_blockquote]:border-muted-foreground [&_blockquote]:pl-4 [&_blockquote]:italic',
                '[&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-2',
                '[&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:my-2',
                '[&_li]:my-1',
                '[&_table]:border-collapse [&_table]:w-full [&_table]:my-2',
                '[&_td]:border [&_td]:border-border [&_td]:p-2',
                '[&_th]:border [&_th]:border-border [&_th]:p-2 [&_th]:bg-muted [&_th]:font-semibold',
                '[&_a]:text-primary [&_a]:underline',
                disabled && 'pointer-events-none',
                className
            )}
            placeholder={placeholder}
            readOnly={disabled}
            autoFocus={false}
        />
    );
};

export default EditorContent;
